import React from "react"
import {IndexRoute, Link, Redirect, Route, Switch, withRouter} from "react-router-dom";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import ImportantDocumentEdit from "./edit";
import ImportantDocumentsList from "./list";

class ImportantDocuments extends React.Component {

    render() {
        let important_documents = this.props.important_documents.list;

        return (
            <Switch>
                <Route path="/important-documents/:id" component={ImportantDocumentEdit}/>
                <Route path="/important-documents" component={ImportantDocumentsList}/>
                <Redirect to='/important-documents'/>
            </Switch>
        )
    };
}

function mapStateToProps(state,ownProps) {
    return {
        important_documents: state.important_documents
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(ImportantDocuments));
